<template>
  <div class="body_area">
    <dev-total-app-main />
  </div>
</template>


<script>
import DevTotalAppMain from "@/components/dev/DevTotalAppMain.vue";

export default {
  name: 'DevFirstLayout',
  components: {
    DevTotalAppMain
  },
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
    console.log('DevFirstLayout created')
  },
  mounted() {
    console.log('DevFirstLayout created')
  },
  beforeDestroy() {
    console.log('DevFirstLayout beforeDestroy')
  }
}
</script>
<style>
/* custom dev css */
@import "../assets/css/dev/DevMain.css";
</style>
